import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a8e7316a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=a8e7316a&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=a8e7316a&prod&lang=less"
import style2 from "@/assets/style/pages/management/aiService/index.less?vue&type=style&index=2&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8e7316a",
  null
  
)

export default component.exports